import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/FooterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/HeaderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/index.css");
